export default "__VITE_ASSET__BkY$_uu___"